export default __webpack_public_path__ + "static/media/lectureNotes.1c1d1aea.svg";